import { gql } from '@apollo/client'

export const rateCompanyBranch = gql`
mutation RateCompanyBranch($moveId: String!, $payload: CompanyRatingDto!) {
  rateCompanyBranch(moveId: $moveId, payload: $payload)
}
`
